import { useMemo } from "react";

import { HUB_CACHE_CHANNEL, type HubCacheSseEvent } from "@/lib/hubCacheChannels";
import { useHubCacheStream } from "@/lib/useHubCacheStream";

export function isHubPagePresenceEvent(event: HubCacheSseEvent): boolean {
  return event.phase === "invalidated" && event.page_presence_reason != null;
}

/** Subscribe to hub-cache SSE channels for page-presence fan-out. */
export function useHubPagePresenceStream(options: {
  scope: "global" | "route";
  routeKey?: string | null;
  enabled?: boolean;
  connectionKey?: string | null;
  onPresenceChange: () => void;
}): void {
  const channels = useMemo(() => {
    if (options.scope === "global") {
      return [HUB_CACHE_CHANNEL.hubPagePresenceAll];
    }
    if (options.routeKey != null && options.routeKey.trim() !== "") {
      return [HUB_CACHE_CHANNEL.hubPagePresenceRoute(options.routeKey)];
    }
    return [];
  }, [options.routeKey, options.scope]);

  useHubCacheStream({
    channels,
    enabled: options.enabled !== false,
    connectionKey: options.connectionKey,
    onEvent: (event) => {
      if (event.phase === "connected" || isHubPagePresenceEvent(event)) {
        options.onPresenceChange();
      }
    },
  });
}
